import { send } from '../../../../../../src/network/network';
import { type CustomerFavoriteProducts } from '../../../../../../src/types/CustomerFavoriteProducts';
export { type CustomerFavoriteProducts } from '../../../../../../src/types/CustomerFavoriteProducts';

type GetFavoriteProductsParams = {
  customerId: number;
};

export const getFavoriteProductsPath = ({
  customerId,
}: GetFavoriteProductsParams) =>
  `/api/v2/customers/${customerId}/favorite_products/`;

export async function getApiV2CustomersCustomerIdFavoriteProducts({
  customerId,
}: GetFavoriteProductsParams) {
  return await send<CustomerFavoriteProducts>({
    path: getFavoriteProductsPath({ customerId }),
    method: 'GET',
  });
}
